import { getShortenedUrlwithGeneral, sanitizeUrl } from "@/utils/helper"

// get component social share link url
export const getLink = data => {
  const { href, url = "", assetUrl = "", compUrl = "", general } = data
  const isFullUrl = /^https?:\/\//i
  const browserOrigin = globalThis.location?.origin ?? ""
  const browserHref = globalThis.location?.href ?? ""

  if (url && isFullUrl.test(url)) {
    return url
  }
  if (url) {
    return `${browserOrigin}${url}`
  } else if (assetUrl && compUrl) {
    // teaser video component link all cases
    if (!isFullUrl.test(compUrl)) {
      const newcompUrl = getShortenedUrlwithGeneral(compUrl, general)
      return `${browserOrigin}${newcompUrl}`
    } else {
      return compUrl
    }
  } else if (assetUrl) {
    return assetUrl
  } else {
    return sanitizeUrl(href || browserHref)
  }
}
